import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabsContentChequeRemittance } from '../../../../../shared/models/tabs-content-cheque-remittance';
import { ChequeRemittanceDetailsAccountMovesComponent } from '../cheque-remittance-details-tab/cheque-remittance-details-account-moves/cheque-remittance-details-account-moves.component';

@Component({
  selector: 'app-cheque-remittance-tabs-details',
  standalone: false,
  templateUrl: './cheque-remittance-tabs-details.component.html',
  styleUrl: './cheque-remittance-tabs-details.component.scss',
})
export class ChequeRemittanceTabsDetailsComponent
  implements OnInit, OnChanges, OnDestroy
{
  active = 1;
  currentActive: number = 1;

  tabsContent$: BehaviorSubject<TabsContentChequeRemittance[]> =
    new BehaviorSubject<TabsContentChequeRemittance[]>([]);
  tabsInit: TabsContentChequeRemittance[] = [
    {
      title: 'CHEQUE_REMITTANCE_TABS_ACCOUNT_MOVES',
      index: 1,
      name: 'chequeRemittanceAccountMoves',
      component: ChequeRemittanceDetailsAccountMovesComponent,
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.tabsContent$.next(this.tabsInit);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentActive) {
      this.active = this.currentActive;
    } else {
      this.active = 1;
    }
    this.tabsContent$.next(this.tabsInit);
  }

  onActiveIdChangeSaveCurrent(active: number) {
    this.currentActive = active;
  }

  ngOnDestroy(): void {
    this.currentActive = 0;
  }
}
